import * as React from "react";
import classNames from "classnames";
import { ContainerProps } from "../../types";

import "./ContainerStyles.scss";

/**
 * Responsive layout container. Wraps content in a `<div>` with optional max-width presets,
 * flex layout, padding, and spacing helpers.
 *
 * @example
 * ```tsx
 * // Centered medium-width page section
 * <Container screen="md" direction="column" spacing={16}>
 *   <CPText textStyle="h2">Section Title</CPText>
 *   <CPText>Section body content.</CPText>
 * </Container>
 *
 * // Full-width fluid row
 * <Container fluid direction="row" justified="space-between">
 *   <Box>Left</Box>
 *   <Box>Right</Box>
 * </Container>
 * ```
 */
const Container: React.FC<ContainerProps> = (props) => {
  return (
    <div
      id={props.id}
      className={classNames(
        "cp-container",
        props.className,
        props.screen,
        props.fluid,
      )}
      style={{
        ...props.style,
        padding: props.padding ?? props.style?.padding,
        width: props.width ?? props.style?.width,
        display: props.display,
        justifyContent: props.justified,
        alignItems: props.aligned,
        flexDirection: props.direction,
        gap: props.spacing,
        flexWrap: props.wrap ? "wrap" : "nowrap",
      }}
    >
      {props.children}
    </div>
  );
};

export default Container;
